import { API_ROOT, APP_CNAME, SSO_BASE_URL } from '../constants';

export const getSSOLoginUrl = () => {
  return `${SSO_BASE_URL}/login?source=ams&cname=${APP_CNAME}`;
};

export const setAuthSession = userData => {
  if (userData && userData.token) {
    localStorage.setItem('token', userData.token);
    localStorage.setItem('user', JSON.stringify(userData));
  }
};

export const fetchSsoSession = async () => {
  const response = await fetch(`${API_ROOT}/sso`, {
    credentials: 'include'
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || 'Failed to authenticate with SSO');
  }

  return response.json();
};
